const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ===== RyeCentral: 'Jump to Products' button on collection headers ===== */
(function(){
  function add(){
    try{
      if(!document.body.classList.contains('template-collection')) return;
      var toggle=document.querySelector('.v2-collection-banner .v2-read-more-toggle');
      var grid=document.getElementById('ProductGridContainer');
      if(!toggle||!grid) return;
      if(toggle.querySelector('.rc-jump-products')) return;
      var btn=document.createElement('a');
      btn.href='#ProductGridContainer';
      btn.className='v2-toggle-btn rc-jump-products';
      btn.setAttribute('role','button');
      btn.textContent='Jump to Products ▾';
      btn.addEventListener('click',function(e){e.preventDefault();grid.scrollIntoView({behavior:'smooth',block:'start'});});
      toggle.appendChild(btn);
    }catch(e){}
  }
  if(document.readyState!=='loading'){add();}else{document.addEventListener('DOMContentLoaded',add);}
})();
